<pos-app-spinner [show]="isLoading"></pos-app-spinner>
<ng-template #content let-c="close" let-d="dismiss">
  <div class="modal-header">
    <h3 class="arb-large-heading" id="modal-basic-title">IMPERSONATE PARTNER</h3>
  </div>
  <div class="modal-body">
    <div class="form-horizontal">
      <div class="form-group">
        <div class="row align-items-center">
          <pos-app-lib-customer-external-search
            (selectNewCustomer)="selectCustomer($event)"
            [selectedCustomerName]="
              selectedCustomer ? selectedCustomer?.customerName + ' (' + selectedCustomer?.customerNumber + ')' : selectedCustomerName || ''
            "
            [disabled]="preSelectedCustomerNumber"
            [showSearchIcon]="true"
            [removeCustomerAfterLoad]="false"
            placeHolder="USER SEARCH"
            (focus)="isFocus($event)"
          ></pos-app-lib-customer-external-search>
        </div>
      </div>

      <div class="modal-footer">
        <button class="btn" (click)="submitChangePartner()" [disabled]="isLoading || !selectedCustomer">IMPERSONATE</button>
        <button class="btn btn-cancel" (click)="cancel()">CANCEL</button>
      </div>
    </div>
  </div>
</ng-template>
